import { supabase } from '../config/supabase';
import { TABLES } from '../data/tables';
import { Country } from '../data/types/domain';

export const countryService = {
  async getCountries(): Promise<Country[]> {
    const { data, error } = await supabase
      .from(TABLES.COUNTRY)
      .select('*');
    
    if (error) throw error;
    return data || [];
  },

  async getCountryById(id: number): Promise<Country | null> {
    const { data, error } = await supabase
      .from(TABLES.COUNTRY)
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data || null;
  },

  async createCountry(country: Omit<Country, 'id' | 'created_at' | 'updated_at'>): Promise<Country> {
    const { data, error } = await supabase
      .from(TABLES.COUNTRY)
      .insert([{
        ...country,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      }])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async updateCountry(
    id: number,
    updates: Partial<Omit<Country, 'id' | 'created_at' | 'updated_at'>>
  ): Promise<Country> {
    const { data, error } = await supabase
      .from(TABLES.COUNTRY)
      .update({
        ...updates,
        updated_at: new Date().toISOString(),
      })
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async deleteCountry(id: number): Promise<void> {
    const { error } = await supabase
      .from(TABLES.COUNTRY)
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  },

  async updateName(id: number, name: string): Promise<Country> {
    return this.updateCountry(id, { name });
  },

  findCountryByName: async (countryName: string) => {
    const { data: existingCountry } = await supabase
      .from(TABLES.COUNTRY)
      .select('*')
      .ilike('name', countryName)
      .single();
    
    return existingCountry;
  }
}; 